"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cabecalho = void 0;
var react_1 = __importDefault(require("react"));
var Breadcrumb_1 = require("../Breadcrumb/Breadcrumb");
var Avatar_1 = require("../Avatar/Avatar");
var Titulo_1 = require("../Tipografia/Titulo/Titulo");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var estiloCabecalho = require("./Cabecalho.module.scss");
var Cabecalho = function (_a) {
    var titulo = _a.titulo, filialLoja = _a.filialLoja, nomeApi = _a.nomeApi, versaoApi = _a.versaoApi, versao = _a.versao, avatar = _a.avatar, _b = _a.breadcrumbs, breadcrumbs = _b === void 0 ? [
        {
            texto: "Início",
            icone: "home",
            onClick: function () { },
        },
    ] : _b;
    var breadcrumbRender = function () {
        return (react_1.default.createElement("div", { className: estiloCabecalho.breadcrumb },
            react_1.default.createElement(Breadcrumb_1.Breadcrumb, { crumbs: breadcrumbs || [] })));
    };
    var tituloRender = function () {
        return (react_1.default.createElement(Titulo_1.Titulo, { tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600, negrito: true, tipo: "cabecalho1" }, titulo));
    };
    var avatarRender = function () {
        return (react_1.default.createElement("div", { className: estiloCabecalho.avatar }, avatar && (react_1.default.createElement(Avatar_1.Avatar, { src: avatar.src, alt: avatar.alt, tamanho: avatar.tamanho, tipo: avatar.tipo, showNotificacao: avatar.showNotificacao, notificacao: avatar.showNotificacao ? avatar.notificacao : undefined }))));
    };
    var filialRender = function () {
        return (react_1.default.createElement("div", { className: estiloCabecalho.informacoesRenderizadas },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "label3", negrito: 700, tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, "Filial"),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", negrito: 500, tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, filialLoja)));
    };
    var versaoApiLabel = react_1.default.createElement("div", { className: estiloCabecalho.informacoesRenderizadas },
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "label3", negrito: 700, tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, nomeApi !== null && nomeApi !== void 0 ? nomeApi : "Api Enterprise"),
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", negrito: 500, tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, versaoApi));
    var versaoRender = function () {
        return (react_1.default.createElement("div", { className: estiloCabecalho.informacoesRenderizadas },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "label3", negrito: 700, tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600 }, "Vers\u00E3o"),
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", negrito: 500, tag: "div", cor: Cores_1.Cores.TextoPadrao.CinzaMU600, style: { textTransform: "none" } }, versao)));
    };
    return (react_1.default.createElement("div", { className: estiloCabecalho.conteudo },
        react_1.default.createElement("div", { className: estiloCabecalho.conteudoEsquerda },
            breadcrumbRender(),
            tituloRender()),
        react_1.default.createElement("div", { className: estiloCabecalho.conteudoDireita },
            avatarRender(),
            filialRender(),
            versaoApiLabel,
            versaoRender())));
};
exports.Cabecalho = Cabecalho;
